import React from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";

function Sidebar({ isOpen, closeSidebar }) {
  return (
    <div className={isOpen ? "sidebar open" : "sidebar"}>
      <button className="close-btn" onClick={closeSidebar}>×</button>

      <ul>
        <li>
          <Link to="/testcases" onClick={closeSidebar}>🧪 AI Test Case Generator</Link>
        </li>
        <li>
          <Link to="/bug-analyzer" onClick={closeSidebar}>🐞 Bug Severity Analyzer</Link>
        </li>
        <li>
          <Link to="/script-writer" onClick={closeSidebar}>💻 Automation Script Writer</Link>
        </li>
        <li>
          <Link to="/test-summary" onClick={closeSidebar}>📄 AI Test Summary</Link>
        </li>

        <hr />

        <li>
          <Link to="/qa-chatbot" onClick={closeSidebar}>🤖 QA Chatbot</Link>
        </li>
       
        <li>
          <Link to="/interview-questions" className="sidebar-link" onClick={closeSidebar}>
           <span className="sidebar-icon">❓Interview Questions</span>
            </Link>
        </li>
        <li>
          <Link to="/about" onClick={closeSidebar}>📌 About</Link>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
